<template>
  <div class="account-auth-form-content">
    <div class="old-mb-4 old-mt-6">
      <ValidationProvider
        name="password"
        rules="required|min:6"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          name="customer[password]"
          type="password"
          v-model="password"
          label="Password"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <div class="old-mb-4">
      <ValidationProvider
        name="password"
        rules="required|confirmed:password"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          name="customer[password_confirmation]"
          type="password"
          v-model="confirmPassword"
          label="Confirm Password"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <input
      class="submit-button plaid-l fs-12"
      type="submit"
      value="RESET PASSWORD"
    />
  </div>
</template>

<script>
export default {
  name: "reset-password-form",
  data() {
    return {
      success: false,
      password: "",
      confirmPassword: "",
    };
  },
};
</script>
